module.exports = __webpack_public_path__ + "img/inventory-bulk-update-type.a609adb4.png";